type BackgroundTurnHandoff = {
  resolve: () => void;
  resumeStarted: boolean;
};

export type BackgroundTurnHandoffConsumption =
  | 'none'
  | 'pending'
  | 'resume-started';

const handoffs = new Map<string, BackgroundTurnHandoff>();

export function beginBackgroundTurnHandoff(chatId: string): Promise<void> {
  let resolveSettled: () => void = () => undefined;
  const settled = new Promise<void>((resolve) => {
    resolveSettled = resolve;
  });

  handoffs.set(chatId, { resolve: resolveSettled, resumeStarted: false });

  return settled;
}

export function markBackgroundTurnResumeStarted(chatId: string): void {
  const handoff = handoffs.get(chatId);

  if (!handoff) {
    return;
  }

  handoff.resumeStarted = true;
}

export function consumeBackgroundTurnHandoff(
  chatId: string,
): BackgroundTurnHandoffConsumption {
  const handoff = handoffs.get(chatId);

  if (!handoff) {
    return 'none';
  }

  handoffs.delete(chatId);
  handoff.resolve();

  return handoff.resumeStarted ? 'resume-started' : 'pending';
}
